import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Modal } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import '../Turnero.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faBuilding, faClock, faMapMarkerAlt, faPhone, faEnvelope, faSave, faEdit, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';

/**
 * SucursalABM - Management of Branches for a selected Company
 */
const SucursalABM = ({ ipserv, hideHeader = false }) => {
    const [loading, setLoading] = useState(false);
    const [branches, setBranches] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [formData, setFormData] = useState({
        EmpresaId: '',
        SucursalNombre: '',
        SucursalHorario: '',
        SucursalDireccion: '',
        SucursalTelefono: '',
        SucursalEmail: ''
    });
    const [subStatus, setSubStatus] = useState(null);

    const loadData = () => {
        setLoading(true);
        // Load Companies for the selector
        request.Get(ipserv + 'turnero/companies', {}, r => {
            if (r.success) setCompanies(r.data || []);
        });

        // Load all Branches (the backend should handle scoping to the logged admin)
        request.Get(ipserv + 'turnero/branches', {}, r => {
            if (r.success) setBranches(r.data || []);
            setLoading(false);
        });
    };

    const loadSubscription = () => {
        request.Get(ipserv + 'turnero/subscription-status', {}, r => {
            if (r.success) setSubStatus(r);
        });
    };

    useEffect(() => {
        loadData();
        loadSubscription();
    }, []);

    const handleOpenModal = (item = null) => {
        setCurrentItem(item);
        setFormData(item || {
            EmpresaId: '',
            SucursalNombre: '',
            SucursalHorario: '',
            SucursalDireccion: '',
            SucursalTelefono: '',
            SucursalEmail: ''
        });
        setShowModal(true);
    };

    const handleSave = (e) => {
        e.preventDefault();
        setLoading(true);
        request.Post(ipserv + 'turnero/saveBranch', { ...formData, SucursalId: currentItem?.SucursalId }, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Sucursal guardada correctamente' });
                setShowModal(false);
                loadData();
            } else {
                Notify({ type: 'fail', text: r.message || 'Error al guardar sucursal' });
            }
            setLoading(false);
        });
    };

    return (
        <div className="animate-in">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 style={{ fontWeight: 800, marginBottom: '0.25rem' }}>Sus Sucursales</h2>
                    <p className="text-muted small">Configura las sedes físicas y puntos de atención de tu empresa.</p>
                </div>
                <button 
                    className={`auth-btn-primary ${(!subStatus || subStatus.isExpired || branches.length >= subStatus.plan.MaxSucursales) ? 'opacity-50' : ''}`} 
                    style={{ width: 'auto', padding: '0.75rem 1.5rem' }} 
                    onClick={() => {
                        if (subStatus?.isExpired) {
                            Notify({ type: 'info', text: 'Tu plan ha vencido. Pásate a modo suscripción para seguir creando.' });
                        } else if (subStatus && branches.length >= subStatus.plan.MaxSucursales) {
                            Notify({ type: 'info', text: `Límite de sucursales alcanzado (${subStatus.plan.MaxSucursales}) para tu plan ${subStatus.plan.PlanNombre}.` });
                        } else {
                            handleOpenModal();
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> Nueva Sucursal
                </button>
            </div>


            <div className="turnero-card p-0 overflow-hidden">
                <table className="table table-dark table-hover m-0">
                    <thead className="bg-glass">
                        <tr>
                            <th className="border-0 p-3">Nombre</th>
                            <th className="border-0 p-3">Empresa</th>
                            <th className="border-0 p-3">Horario</th>
                            <th className="border-0 p-3">Contacto</th>
                            <th className="border-0 p-3 text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && branches.length === 0 ? (
                            <tr><td colSpan="5" className="text-center p-5"><Spinner animation="border" /></td></tr>
                        ) : branches.length === 0 ? (
                            <tr><td colSpan="5" className="text-center p-5 text-muted">No hay sucursales cargadas</td></tr>
                        ) : (
                            branches.map(br => (
                                <tr key={br.SucursalId} className="animate-in">
                                    <td className="p-3 font-weight-bold">{br.SucursalNombre}</td>
                                    <td className="p-3">
                                        <span className="turnero-badge bg-info">
                                            {companies.find(c => c.EmpresaId === br.EmpresaId)?.EmpresaNombre || 'N/A'}
                                        </span>
                                    </td>
                                    <td className="p-3">{br.SucursalHorario}</td>
                                    <td className="p-3 small">
                                        <div>{br.SucursalEmail}</div>
                                        <div>{br.SucursalTelefono}</div>
                                    </td>
                                    <td className="p-3 text-center">
                                        <button className="btn btn-sm btn-outline-info mr-2" onClick={() => handleOpenModal(br)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button className="btn btn-sm btn-outline-danger">
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg" contentClassName="turnero-card border-0">
                <form onSubmit={handleSave}>
                    <Modal.Body className="text-white px-4 py-4">
                        <h4 className="mb-4">{currentItem ? 'Editar Sucursal' : 'Nueva Sucursal'}</h4>

                        <div className="form-header-section">
                            <FontAwesomeIcon icon={faStore} /> Información de Sucursal
                        </div>
                        <Row>
                            <Col md={12} className="mb-3">
                                <label className="small text-muted mb-1">Empresa Perteneciente</label>
                                <div className="position-relative">
                                    <FontAwesomeIcon icon={faBuilding} className="position-absolute" style={{ left: '1rem', top: '1rem', opacity: 0.5, zIndex: 10 }} />
                                    <select
                                        className="turnero-input"
                                        style={{ paddingLeft: '3rem' }}
                                        value={formData.EmpresaId}
                                        onChange={e => setFormData({ ...formData, EmpresaId: e.target.value })}
                                        required
                                    >
                                        <option value="" disabled>Seleccione una empresa...</option>
                                        {companies.map(c => (
                                            <option key={c.EmpresaId} value={c.EmpresaId}>{c.EmpresaNombre}</option>
                                        ))}
                                    </select>
                                </div>
                            </Col>
                            <Col md={7} className="mb-3">
                                <label className="small text-muted mb-1">Nombre de la Sucursal / Sede</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    placeholder="Ej: Sucursal Centro"
                                    value={formData.SucursalNombre}
                                    onChange={e => setFormData({ ...formData, SucursalNombre: e.target.value })}
                                    required
                                />
                            </Col>
                            <Col md={5} className="mb-3">
                                <label className="small text-muted mb-1">Horario de Atención</label>
                                <div className="position-relative">
                                    <FontAwesomeIcon icon={faClock} className="position-absolute" style={{ left: '1rem', top: '1rem', opacity: 0.5 }} />
                                    <input
                                        type="text"
                                        className="turnero-input"
                                        style={{ paddingLeft: '3rem' }}
                                        placeholder="Lun a Vie 9-18hs"
                                        value={formData.SucursalHorario}
                                        onChange={e => setFormData({ ...formData, SucursalHorario: e.target.value })}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <div className="turnero-separator"></div>

                        <div className="form-header-section">
                            <FontAwesomeIcon icon={faMapMarkerAlt} /> Ubicación y Contacto
                        </div>
                        <Row>
                            <Col md={12} className="mb-3">
                                <label className="small text-muted mb-1">Dirección de la Sucursal</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    value={formData.SucursalDireccion}
                                    onChange={e => setFormData({ ...formData, SucursalDireccion: e.target.value })}
                                    required
                                />
                            </Col>
                            <Col md={6} className="mb-3">
                                <label className="small text-muted mb-1">Teléfono Directo</label>
                                <div className="position-relative">
                                    <FontAwesomeIcon icon={faPhone} className="position-absolute" style={{ left: '1rem', top: '1rem', opacity: 0.5 }} />
                                    <input
                                        type="text"
                                        className="turnero-input"
                                        style={{ paddingLeft: '3rem' }}
                                        value={formData.SucursalTelefono}
                                        onChange={e => setFormData({ ...formData, SucursalTelefono: e.target.value })}
                                    />
                                </div>
                            </Col>
                            <Col md={6} className="mb-3">
                                <label className="small text-muted mb-1">Mail de la Sucursal</label>
                                <div className="position-relative">
                                    <FontAwesomeIcon icon={faEnvelope} className="position-absolute" style={{ left: '1rem', top: '1rem', opacity: 0.5 }} />
                                    <input
                                        type="email"
                                        className="turnero-input"
                                        style={{ paddingLeft: '3rem' }}
                                        value={formData.SucursalEmail}
                                        onChange={e => setFormData({ ...formData, SucursalEmail: e.target.value })}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer className="border-0 px-4 pb-4">
                        <button type="button" className="btn btn-link text-muted" onClick={() => setShowModal(false)}>
                            Cancelar
                        </button>
                        <button type="submit" className="turnero-btn turnero-btn-primary px-5" disabled={loading}>
                            {loading ? <Spinner size="sm" animation="border" /> : (
                                <><FontAwesomeIcon icon={faSave} className="mr-2" /> {currentItem ? 'Actualizar' : 'Crear Sucursal'}</>
                            )}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    );
};

export default SucursalABM;
